import { useContext } from 'react'

import { AdminBreakersContext } from '@/model/contexts/AdminBreakersProvider.tsx'

export type { AdminBreakersContextValue } from './AdminBreakersProvider.tsx'

export const useAdminBreakers = () => useContext(AdminBreakersContext)
